import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/store/user'
import { ensureCompany } from '@/utils/company'

import purchaseRoutes from './modules/purchase'
import saleRoutes from './modules/sale'
import inventoryRoutes from './modules/inventory'
import financeRoutes from './modules/finance'
import baseRoutes from './modules/base'
import assetRoutes from './modules/assets'
import shareholderRoutes from './modules/shareholder'
import crmRoutes from './modules/crm'
import manufactureRoutes from './modules/manufacture'
import projectRoutes from './modules/project'
import settingsRoutes from './modules/settings'
import hrRoutes from './modules/hr'
import qualityRoutes from './modules/quality'
import supportRoutes from './modules/support'
import posRoutes from './modules/pos'
import websiteRoutes from './modules/website'
import oaRoutes from './modules/oa'
import cashierRoutes from './modules/cashier'

const Layout = () => import('@/layout/DefaultLayout.vue')

const staticRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', hidden: true },
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '经营工作台', icon: 'icon-dashboard' },
      },
      purchaseRoutes,
      saleRoutes,
      inventoryRoutes,
      financeRoutes,
      hrRoutes,
      assetRoutes,
      shareholderRoutes,
      crmRoutes,
      manufactureRoutes,
      projectRoutes,
      qualityRoutes,
      supportRoutes,
      posRoutes,
      websiteRoutes,
      oaRoutes,
      cashierRoutes,
      settingsRoutes,
      baseRoutes,
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { title: '404', hidden: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: staticRoutes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()
  document.title = `${to.meta.title || 'Arco ERP'} - Arco ERP`

  if (to.path === '/login') { next(); return }

  if (!userStore.isLoggedIn) { next('/login'); return }

  // 已登录但 company 为空时自动补全（兼容旧会话）
  ensureCompany()

  const requiredPerms = to.meta.permissions as string[] | undefined
  if (requiredPerms && requiredPerms.length > 0) {
    if (!userStore.hasAnyPermission(requiredPerms)) {
      next('/dashboard'); return
    }
  }

  next()
})

export default router
